(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-http.js', './ktor-ktor-serialization.js', './ktor-ktor-io.js', './ktor-ktor-client-core.js', './ktor-ktor-utils.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-serialization.js'), require('./ktor-ktor-io.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-utils.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-serialization'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-serialization' was not found. Please, check whether 'ktor-ktor-serialization' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    globalThis['ktor-ktor-client-content-negotiation'] = factory(typeof globalThis['ktor-ktor-client-content-negotiation'] === 'undefined' ? {} : globalThis['ktor-ktor-client-content-negotiation'], globalThis['kotlin-kotlin-stdlib'], globalThis['ktor-ktor-http'], globalThis['ktor-ktor-serialization'], globalThis['ktor-ktor-io'], globalThis['ktor-ktor-client-core'], globalThis['ktor-ktor-utils']);
  }
}(function (_, kotlin_kotlin, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_serialization, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_utils) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var plus = kotlin_kotlin.$_$.fb;
  var toMutableSet = kotlin_kotlin.$_$.sc;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var register$default = kotlin_io_ktor_ktor_serialization.$_$.b;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var Configuration = kotlin_io_ktor_ktor_serialization.$_$.c;
  var VOID = kotlin_kotlin.$_$.d;
  var Exception = kotlin_kotlin.$_$.gn;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var toString = kotlin_kotlin.$_$.hh;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.b;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var TransformRequestBodyContext = kotlin_io_ktor_ktor_client_core.$_$.h;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.q;
  var TypeInfo = kotlin_io_ktor_ktor_utils.$_$.l;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var TransformResponseBodyContext = kotlin_io_ktor_ktor_client_core.$_$.i;
  var HttpResponse = kotlin_io_ktor_ktor_client_core.$_$.y;
  var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.m1;
  var isInterface = kotlin_kotlin.$_$.rg;
  var contentType = kotlin_io_ktor_ktor_http.$_$.p1;
  var charset = kotlin_io_ktor_ktor_http.$_$.l1;
  var get_request = kotlin_io_ktor_ktor_client_core.$_$.a1;
  var Collection = kotlin_kotlin.$_$.y6;
  var emptyList = kotlin_kotlin.$_$.c9;
  var Companion_getInstance = kotlin_io_ktor_ktor_http.$_$.c;
  var accept = kotlin_io_ktor_ktor_client_core.$_$.r;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.t;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var contentType_0 = kotlin_io_ktor_ktor_http.$_$.n1;
  var EmptyContent_getInstance = kotlin_io_ktor_ktor_client_core.$_$.d;
  var Unit = kotlin_kotlin.$_$.co;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var equals = kotlin_kotlin.$_$.sf;
  var joinToString = kotlin_kotlin.$_$.aa;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var deserialize = kotlin_io_ktor_ktor_serialization.$_$.a;
  var KtorSimpleLogger = kotlin_io_ktor_ktor_utils.$_$.g;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.b3;
  var HttpStatusCode = kotlin_io_ktor_ktor_http.$_$.y;
  var getKClass = kotlin_kotlin.$_$.si;
  var ClientSSESession = kotlin_io_ktor_ktor_client_core.$_$.l;
  var ClientSSESessionWithDeserialization = kotlin_io_ktor_ktor_client_core.$_$.k;
  var setOf = kotlin_kotlin.$_$.sb;
  var KtList = kotlin_kotlin.$_$.e7;
  var ContentType = kotlin_io_ktor_ktor_http.$_$.w;
  var arrayOf = kotlin_kotlin.$_$.fo;
  var createKType = kotlin_kotlin.$_$.qi;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.oi;
  var AttributeKey = kotlin_io_ktor_ktor_utils.$_$.n;
  var createClientPlugin = kotlin_io_ktor_ktor_client_core.$_$.j;
  var endsWith = kotlin_kotlin.$_$.vj;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ConverterRegistration, 'ConverterRegistration');
  initMetadataForClass(ContentNegotiationConfig$defaultMatcher$1);
  initMetadataForClass(ContentNegotiationConfig, 'ContentNegotiationConfig', ContentNegotiationConfig, VOID, [Configuration]);
  initMetadataForClass(ContentConverterException, 'ContentConverterException', VOID, Exception);
  initMetadataForLambda(ContentNegotiation$lambda$slambda, CoroutineImpl, VOID, [4]);
  initMetadataForLambda(ContentNegotiation$lambda$slambda_1, CoroutineImpl, VOID, [4]);
  initMetadataForCoroutine($invoke$convertRequestCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($invoke$convertResponseCOROUTINE$, CoroutineImpl);
  initMetadataForObject(JsonContentTypeMatcher, 'JsonContentTypeMatcher');
  //endregion
  function get_LOGGER() {
    _init_properties_ContentNegotiation_kt__o183go();
    return LOGGER;
  }
  var LOGGER;
  function get_DefaultCommonIgnoredTypes() {
    _init_properties_ContentNegotiation_kt__o183go();
    return DefaultCommonIgnoredTypes;
  }
  var DefaultCommonIgnoredTypes;
  function get_ExcludedContentTypes() {
    _init_properties_ContentNegotiation_kt__o183go();
    return ExcludedContentTypes;
  }
  var ExcludedContentTypes;
  function get_ContentNegotiation() {
    _init_properties_ContentNegotiation_kt__o183go();
    return ContentNegotiation;
  }
  var ContentNegotiation;
  function ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher) {
    this.wv9_1 = converter;
    this.xv9_1 = contentTypeToSend;
    this.yv9_1 = contentTypeMatcher;
  }
  function defaultMatcher($this, pattern) {
    return new ContentNegotiationConfig$defaultMatcher$1(pattern);
  }
  function ContentNegotiationConfig$defaultMatcher$1($pattern) {
    this.zv9_1 = $pattern;
  }
  protoOf(ContentNegotiationConfig$defaultMatcher$1).ava = function (contentType) {
    return contentType.tsx(this.zv9_1);
  };
  function ContentNegotiationConfig() {
    this.bva_1 = toMutableSet(plus(get_DefaultIgnoredTypes(), get_DefaultCommonIgnoredTypes()));
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.cva_1 = ArrayList_init_$Create$();
    this.dva_1 = null;
  }
  protoOf(ContentNegotiationConfig).wtn = function (contentType, converter, configuration) {
    var matcher = contentType.tsx(Application_getInstance().ksv_1) ? JsonContentTypeMatcher_instance : defaultMatcher(this, contentType);
    this.eva(contentType, converter, matcher, configuration);
  };
  protoOf(ContentNegotiationConfig).eva = function (contentTypeToSend, converter, contentTypeMatcher, configuration) {
    // Inline function 'kotlin.apply' call
    configuration(converter);
    var registration = new ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher);
    this.cva_1.j1(registration);
  };
  function ContentConverterException(message) {
    Exception_init_$Init$(message, this);
    captureStack(this, ContentConverterException);
  }
  function ContentNegotiationConfig$_init_$ref_1ne3ob() {
    return constructCallableReference(function () {
      return new ContentNegotiationConfig();
    }, 0, 0, 514, '<init>');
  }
  function ContentNegotiation$lambda($this$createClientPlugin) {
    _init_properties_ContentNegotiation_kt__o183go();
    var registrations = $this$createClientPlugin.xtz_1.cva_1;
    var ignoredTypes = $this$createClientPlugin.xtz_1.bva_1;
    $this$createClientPlugin.cuk(ContentNegotiation$lambda$slambda_0(registrations, $this$createClientPlugin, ignoredTypes, null));
    $this$createClientPlugin.bu9(ContentNegotiation$lambda$slambda_2(ignoredTypes, registrations, $this$createClientPlugin, null));
    return Unit_instance;
  }
  function ContentNegotiation$lambda$convertRequest$lambda(it) {
    _init_properties_ContentNegotiation_kt__o183go();
    return toString(it.wv9_1);
  }
  function invoke$convertRequest(registrations, $this_createClientPlugin, ignoredTypes, request, body, $completion) {
    var tmp = new $invoke$convertRequestCOROUTINE$(registrations, $this_createClientPlugin, ignoredTypes, request, body, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function invoke$convertResponse(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, $completion) {
    charset = charset === VOID ? Charsets_getInstance().psm_1 : charset;
    var tmp = new $invoke$convertResponseCOROUTINE$(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function ContentNegotiation$lambda$slambda($registrations, $this_createClientPlugin, $ignoredTypes, resultContinuation) {
    this.wvb_1 = $registrations;
    this.xvb_1 = $this_createClientPlugin;
    this.yvb_1 = $ignoredTypes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$lambda$slambda).dvc = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion) {
    var tmp = this.evc($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ContentNegotiation$lambda$slambda).gua = function (p1, p2, p3, p4, $completion) {
    var tmp = p1 instanceof TransformRequestBodyContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE();
    var tmp_1 = !(p3 == null) ? p3 : THROW_CCE();
    return this.dvc(tmp, tmp_0, tmp_1, (p4 == null ? true : p4 instanceof TypeInfo) ? p4 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = invoke$convertRequest(this.wvb_1, this.xvb_1, this.yvb_1, this.avc_1, this.bvc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$lambda$slambda).evc = function ($this$transformRequestBody, request, body, _unused_var__etf5q3, completion) {
    var i = new ContentNegotiation$lambda$slambda(this.wvb_1, this.xvb_1, this.yvb_1, completion);
    i.zvb_1 = $this$transformRequestBody;
    i.avc_1 = request;
    i.bvc_1 = body;
    i.cvc_1 = _unused_var__etf5q3;
    return i;
  };
  function ContentNegotiation$lambda$slambda_0($registrations, $this_createClientPlugin, $ignoredTypes, resultContinuation) {
    var i = new ContentNegotiation$lambda$slambda($registrations, $this_createClientPlugin, $ignoredTypes, resultContinuation);
    return constructCallableReference(function ($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion) {
      return i.dvc($this$transformRequestBody, request, body, _unused_var__etf5q3, $completion);
    }, 4);
  }
  function ContentNegotiation$lambda$slambda_1($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation) {
    this.nvc_1 = $ignoredTypes;
    this.ovc_1 = $registrations;
    this.pvc_1 = $this_createClientPlugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$lambda$slambda_1).eua = function ($this$transformResponseBody, response, body, info, $completion) {
    var tmp = this.fua($this$transformResponseBody, response, body, info, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ContentNegotiation$lambda$slambda_1).gua = function (p1, p2, p3, p4, $completion) {
    var tmp = p1 instanceof TransformResponseBodyContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpResponse ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? isInterface(p3, ByteReadChannel) : false) ? p3 : THROW_CCE();
    return this.eua(tmp, tmp_0, tmp_1, p4 instanceof TypeInfo ? p4 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0_elvis_lhs = contentType(this.rvc_1);
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var contentType_0 = tmp_0;
            var tmp1_elvis_lhs = charset(contentType_0);
            var charset_0 = tmp1_elvis_lhs == null ? Charsets_getInstance().psm_1 : tmp1_elvis_lhs;
            this.n9_1 = 1;
            suspendResult = invoke$convertResponse(this.nvc_1, this.ovc_1, this.pvc_1, get_request(this.rvc_1).ott(), this.tvc_1, this.svc_1, contentType_0, charset_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$lambda$slambda_1).fua = function ($this$transformResponseBody, response, body, info, completion) {
    var i = new ContentNegotiation$lambda$slambda_1(this.nvc_1, this.ovc_1, this.pvc_1, completion);
    i.qvc_1 = $this$transformResponseBody;
    i.rvc_1 = response;
    i.svc_1 = body;
    i.tvc_1 = info;
    return i;
  };
  function ContentNegotiation$lambda$slambda_2($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation) {
    var i = new ContentNegotiation$lambda$slambda_1($ignoredTypes, $registrations, $this_createClientPlugin, resultContinuation);
    return constructCallableReference(function ($this$transformResponseBody, response, body, info, $completion) {
      return i.eua($this$transformResponseBody, response, body, info, $completion);
    }, 4);
  }
  function $invoke$convertRequestCOROUTINE$(registrations, $this_createClientPlugin, ignoredTypes, request, body, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nva_1 = registrations;
    this.ova_1 = $this_createClientPlugin;
    this.pva_1 = ignoredTypes;
    this.qva_1 = request;
    this.rva_1 = body;
  }
  protoOf($invoke$convertRequestCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            var tmp_0;
            if (this.qva_1.dts_1.vsn(get_ExcludedContentTypes())) {
              var excluded = this.qva_1.dts_1.tsn(get_ExcludedContentTypes());
              var tmp0 = this.nva_1;
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp0.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                var tmp$ret$0;
                l$ret$1: do {
                  var tmp_1;
                  if (isInterface(excluded, Collection)) {
                    tmp_1 = excluded.r();
                  } else {
                    tmp_1 = false;
                  }
                  if (tmp_1) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                  var _iterator__ex2g4s_0 = excluded.t();
                  while (_iterator__ex2g4s_0.u()) {
                    var element_0 = _iterator__ex2g4s_0.v();
                    if (element.xv9_1.tsx(element_0)) {
                      tmp$ret$0 = false;
                      break l$ret$1;
                    }
                  }
                  tmp$ret$0 = true;
                }
                 while (false);
                if (tmp$ret$0) {
                  destination.j1(element);
                }
              }
              tmp_0 = destination;
            } else {
              tmp_0 = this.nva_1;
            }

            var requestRegistrations = tmp_0;
            var tmp0_elvis_lhs = this.qva_1.ats_1.bsq('Accept');
            var acceptHeaders = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            var _iterator__ex2g4s_1 = requestRegistrations.t();
            while (_iterator__ex2g4s_1.u()) {
              var element_1 = _iterator__ex2g4s_1.v();
              var tmp$ret$2;
              l$ret$3: do {
                var tmp_2;
                if (isInterface(acceptHeaders, Collection)) {
                  tmp_2 = acceptHeaders.r();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$2 = true;
                  break l$ret$3;
                }
                var _iterator__ex2g4s_2 = acceptHeaders.t();
                while (_iterator__ex2g4s_2.u()) {
                  var element_2 = _iterator__ex2g4s_2.v();
                  if (Companion_getInstance().jr(element_2).tsx(element_1.xv9_1)) {
                    tmp$ret$2 = false;
                    break l$ret$3;
                  }
                }
                tmp$ret$2 = true;
              }
               while (false);
              if (tmp$ret$2) {
                var qValue = this.ova_1.xtz_1.dva_1;
                var contentTypeToSend = qValue == null ? element_1.xv9_1 : element_1.xv9_1.rsx('q', qValue.toString());
                get_LOGGER().hsu('Adding Accept=' + contentTypeToSend.toString() + ' header for ' + this.qva_1.ytr_1.toString());
                accept(this.qva_1, contentTypeToSend);
              }
            }

            var tmp_3;
            var tmp_4 = this.rva_1;
            if (tmp_4 instanceof OutgoingContent) {
              tmp_3 = true;
            } else {
              var tmp0_0 = this.pva_1;
              var tmp$ret$4;
              l$ret$5: do {
                var tmp_5;
                if (isInterface(tmp0_0, Collection)) {
                  tmp_5 = tmp0_0.r();
                } else {
                  tmp_5 = false;
                }
                if (tmp_5) {
                  tmp$ret$4 = false;
                  break l$ret$5;
                }
                var _iterator__ex2g4s_3 = tmp0_0.t();
                while (_iterator__ex2g4s_3.u()) {
                  var element_3 = _iterator__ex2g4s_3.v();
                  if (element_3.ob(this.rva_1)) {
                    tmp$ret$4 = true;
                    break l$ret$5;
                  }
                }
                tmp$ret$4 = false;
              }
               while (false);
              tmp_3 = tmp$ret$4;
            }

            if (tmp_3) {
              get_LOGGER().hsu('Body type ' + toString(getKClassFromExpression(this.rva_1)) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.qva_1.ytr_1.toString() + '.'));
              return null;
            }

            var tmp_6 = this;
            var tmp0_elvis_lhs_0 = contentType_0(this.qva_1);
            var tmp_7;
            if (tmp0_elvis_lhs_0 == null) {
              this.ova_1;
              get_LOGGER().hsu("Request doesn't have Content-Type header. Skipping ContentNegotiation for " + this.qva_1.ytr_1.toString() + '.');
              return null;
            } else {
              tmp_7 = tmp0_elvis_lhs_0;
            }

            tmp_6.tva_1 = tmp_7;
            var tmp_8 = this.rva_1;
            if (tmp_8 instanceof Unit) {
              get_LOGGER().hsu('Sending empty body for ' + this.qva_1.ytr_1.toString());
              this.qva_1.ats_1.jsq('Content-Type');
              return EmptyContent_getInstance();
            }

            var tmp_9 = this;
            var tmp0_1 = this.nva_1;
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_4 = tmp0_1.t();
            while (_iterator__ex2g4s_4.u()) {
              var element_4 = _iterator__ex2g4s_4.v();
              if (element_4.yv9_1.ava(this.tva_1)) {
                destination_0.j1(element_4);
              }
            }

            var tmp_10;
            if (!destination_0.r()) {
              tmp_10 = destination_0;
            } else {
              tmp_10 = null;
            }

            var tmp1_elvis_lhs = tmp_10;
            var tmp_11;
            if (tmp1_elvis_lhs == null) {
              this.ova_1;
              get_LOGGER().hsu('None of the registered converters match request Content-Type=' + this.tva_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.qva_1.ytr_1.toString() + '.'));
              return null;
            } else {
              tmp_11 = tmp1_elvis_lhs;
            }

            tmp_9.sva_1 = tmp_11;
            if (this.qva_1.kum() == null) {
              get_LOGGER().hsu('Request has unknown body type. Skipping ContentNegotiation for ' + this.qva_1.ytr_1.toString() + '.');
              return null;
            }

            this.qva_1.ats_1.jsq('Content-Type');
            this.xva_1 = this.sva_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.wva_1 = this.xva_1.t();
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!this.wva_1.u()) {
              this.n9_1 = 5;
              continue $sm;
            }

            var element_5 = this.wva_1.v();
            this.vva_1 = element_5;
            this.n9_1 = 3;
            var tmp0_elvis_lhs_1 = charset(this.tva_1);
            var tmp_12 = tmp0_elvis_lhs_1 == null ? Charsets_getInstance().psm_1 : tmp0_elvis_lhs_1;
            var tmp_13 = ensureNotNull(this.qva_1.kum());
            var this_0 = this.rva_1;
            var tmp_14;
            if (!equals(this_0, NullBody_instance)) {
              tmp_14 = this_0;
            } else {
              tmp_14 = null;
            }

            suspendResult = this.vva_1.wv9_1.uvc(this.tva_1, tmp_12, tmp_13, tmp_14, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var result = suspendResult;
            if (!(result == null)) {
              get_LOGGER().hsu('Converted request body using ' + toString(this.vva_1.wv9_1) + ' for ' + this.qva_1.ytr_1.toString());
            }

            var result_0 = result;
            if (!(result_0 == null)) {
              this.uva_1 = result_0;
              this.n9_1 = 6;
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.n9_1 = 2;
            continue $sm;
          case 5:
            this.uva_1 = null;
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 6;
            continue $sm;
          case 6:
            var tmp2_elvis_lhs = this.uva_1;
            var tmp_15;
            if (tmp2_elvis_lhs == null) {
              var tmp_16 = "Can't convert " + toString(this.rva_1) + ' with contentType ' + this.tva_1.toString() + ' using converters ';
              throw new ContentConverterException(tmp_16 + joinToString(this.sva_1, VOID, VOID, VOID, VOID, VOID, ContentNegotiation$lambda$convertRequest$lambda));
            } else {
              tmp_15 = tmp2_elvis_lhs;
            }

            var serializedContent = tmp_15;
            return serializedContent;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $invoke$convertResponseCOROUTINE$(ignoredTypes, registrations, $this_createClientPlugin, requestUrl, info, body, responseContentType, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gvb_1 = ignoredTypes;
    this.hvb_1 = registrations;
    this.ivb_1 = $this_createClientPlugin;
    this.jvb_1 = requestUrl;
    this.kvb_1 = info;
    this.lvb_1 = body;
    this.mvb_1 = responseContentType;
    this.nvb_1 = charset;
  }
  protoOf($invoke$convertResponseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp_0 = this.lvb_1;
            if (!isInterface(tmp_0, ByteReadChannel)) {
              get_LOGGER().hsu('Response body is already transformed. Skipping ContentNegotiation for ' + this.jvb_1.toString() + '.');
              return null;
            }

            if (this.gvb_1.m1(this.kvb_1.bsu_1)) {
              get_LOGGER().hsu('Response body type ' + toString(this.kvb_1.bsu_1) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.jvb_1.toString() + '.'));
              return null;
            }

            var tmp0 = this.hvb_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (element.yv9_1.ava(this.mvb_1)) {
                destination.j1(element);
              }
            }

            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            var _iterator__ex2g4s_0 = destination.t();
            while (_iterator__ex2g4s_0.u()) {
              var item = _iterator__ex2g4s_0.v();
              destination_0.j1(item.wv9_1);
            }

            var tmp_1;
            if (!destination_0.r()) {
              tmp_1 = destination_0;
            } else {
              tmp_1 = null;
            }

            var tmp0_elvis_lhs = tmp_1;
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              this.ivb_1;
              get_LOGGER().hsu('None of the registered converters match response with Content-Type=' + this.mvb_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.jvb_1.toString() + '.'));
              return null;
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            var suitableConverters = tmp_2;
            this.n9_1 = 1;
            suspendResult = deserialize(suitableConverters, this.lvb_1, this.kvb_1, this.nvb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            if (!isInterface(result, ByteReadChannel)) {
              get_LOGGER().hsu('Response body was converted to ' + toString(getKClassFromExpression(result)) + ' for ' + this.jvb_1.toString() + '.');
            }

            return result;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_ContentNegotiation_kt_1ayduy;
  function _init_properties_ContentNegotiation_kt__o183go() {
    if (!properties_initialized_ContentNegotiation_kt_1ayduy) {
      properties_initialized_ContentNegotiation_kt_1ayduy = true;
      LOGGER = KtorSimpleLogger('io.ktor.client.plugins.contentnegotiation.ContentNegotiation');
      DefaultCommonIgnoredTypes = setOf([PrimitiveClasses_getInstance().vc(), PrimitiveClasses_getInstance().rc(), getKClass(HttpStatusCode), getKClass(ByteReadChannel), getKClass(OutgoingContent), getKClass(ClientSSESession), getKClass(ClientSSESessionWithDeserialization)]);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'ExcludedContentTypesAttr';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(KtList);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ContentType), arrayOf([]), false))]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      ExcludedContentTypes = new AttributeKey(name, tmp$ret$1);
      var tmp_2 = ContentNegotiationConfig$_init_$ref_1ne3ob();
      ContentNegotiation = createClientPlugin('ContentNegotiation', tmp_2, ContentNegotiation$lambda);
    }
  }
  function JsonContentTypeMatcher() {
  }
  protoOf(JsonContentTypeMatcher).ava = function (contentType) {
    if (contentType.tsx(Application_getInstance().ksv_1)) {
      return true;
    }
    var value = contentType.ssx().toString();
    return Application_getInstance().esw(value) && endsWith(value, '+json', true);
  };
  var JsonContentTypeMatcher_instance;
  function JsonContentTypeMatcher_getInstance() {
    return JsonContentTypeMatcher_instance;
  }
  function get_DefaultIgnoredTypes() {
    _init_properties_DefaultIgnoredTypes_web_kt__6eddjw();
    return DefaultIgnoredTypes;
  }
  var DefaultIgnoredTypes;
  var properties_initialized_DefaultIgnoredTypes_web_kt_23uj7m;
  function _init_properties_DefaultIgnoredTypes_web_kt__6eddjw() {
    if (!properties_initialized_DefaultIgnoredTypes_web_kt_23uj7m) {
      properties_initialized_DefaultIgnoredTypes_web_kt_23uj7m = true;
      // Inline function 'kotlin.collections.mutableSetOf' call
      DefaultIgnoredTypes = LinkedHashSet_init_$Create$();
    }
  }
  //region block: post-declaration
  protoOf(ContentNegotiationConfig).xtn = register$default;
  //endregion
  //region block: init
  JsonContentTypeMatcher_instance = new JsonContentTypeMatcher();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = get_ContentNegotiation;
  //endregion
  return _;
}));

//# sourceMappingURL=ktor-ktor-client-content-negotiation.js.map
